export const GET_ENGAGEMENT_INFO_START: string = 'GET_ENGAGEMENT_INFO_START';
export const GET_ENGAGEMENT_INFO_SUCCESS: string = 'GET_ENGAGEMENT_INFO_SUCCESS';
export const GET_ENGAGEMENT_INFO_FAIL: string = 'GET_ENGAGEMENT_INFO_FAIL';
export const SET_ENGAGEMENT_INFO_START: string = 'SET_ENGAGEMENT_INFO_START';
export const SET_ENGAGEMENT_INFO_SUCCESS: string = 'SET_ENGAGEMENT_INFO_SUCCESS';
export const SET_ENGAGEMENT_INFO_FAIL: string = 'SET_ENGAGEMENT_INFO_FAIL';